import React from 'react'
import styled from 'styled-components'
import { Flex, Text } from 'vvs-uikit'
import { CurrencyLogo } from 'views/Info/components/CurrencyLogo'
import { getBalanceNumber } from 'utils/formatBalance'
import { formatAmount } from 'views/Info/utils/formatInfoNumbers'

export interface PoolRewardsProps {
  baseReward: any
  rewardData?: any[]
}

interface TokenWithEmissionProps {
  address: string
  symbol: string
  rewardPerDay: any
}

const TokenRow = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 0.3fr 1.5fr;
  margin-bottom: 5px;
`

const tokenEmissions: React.FunctionComponent<TokenWithEmissionProps> = (token) => {
  return (
    <TokenRow key={token.symbol}>
      <Flex justifySelf="end">
        <Text color="textSubtle">{formatAmount(token.rewardPerDay)}</Text>
      </Flex>
      <Flex />
      <Flex justifySelf="end">
        <Text fontSize="16px" mr="4px" style={{ whiteSpace: 'nowrap' }} width="fit-content">
          {token.symbol}
        </Text>
        <CurrencyLogo address={token.address} size="22px" />
      </Flex>
    </TokenRow>
  )
}

const PoolRewards: React.FunctionComponent<PoolRewardsProps> = ({ baseReward, rewardData }) => {
  const now = Date.now() / 1000
  const vvsRewards = {
    address: baseReward.token.address,
    symbol: baseReward.token.symbol,
    rewardPerDay: baseReward.rewardPerDay,
  }
  const extraTokenRewards = rewardData
    ? rewardData
        .filter((data) => now <= parseInt(data.rewardEndTimestamp))
        .map((data) => {
          const rewardPerDay: number =
            parseInt(data.rewardStartTimestamp) <= now && now <= parseInt(data.rewardEndTimestamp)
              ? getBalanceNumber(data.rewardPerDay, data.token.decimals)
              : 0
          return { address: data.token.address, symbol: data.token.symbol, rewardPerDay }
        })
    : []
  const rewards = [vvsRewards, ...extraTokenRewards]
  return <Flex flexDirection="column">{rewards.map((reward) => tokenEmissions(reward))}</Flex>
}

export default PoolRewards
